import React from 'react';
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import rehypeHighlight from 'rehype-highlight';

const preprocessMarkdown = (text) => {
  return (
    text
      // Convert 3+ newlines into <br /><br />...
      // .replace(/\n{2,}/g, (match) => '\n\n' + '<br />'.repeat(match.length - 1))
      // Convert single newlines (surrounded by non-newlines) into Markdown line breaks
      .replace(/(?<!\n)\n(?!\n)/g, '  \n')
  );
};

export const MarkdownRenderer = ({ content }) => {
  const processed = preprocessMarkdown(content);

  return (
    <ReactMarkdown 
      children={processed} 
      rehypePlugins={[rehypeRaw, rehypeHighlight]}
    />
  );
};
